module.exports = [{
      plugin: require('/home/shin/code/shiga-chinese-class.worktree/107da8e6-4337-48e5-869f-3e1eedd54774/node_modules/gatsby-plugin-canonical-urls/gatsby-browser'),
      options: {"plugins":[],"siteUrl":"https://shiga-chinese-class.netlify.com"},
    },{
      plugin: require('/home/shin/code/shiga-chinese-class.worktree/107da8e6-4337-48e5-869f-3e1eedd54774/node_modules/gatsby-plugin-google-analytics/gatsby-browser'),
      options: {"plugins":[],"trackingId":"UA-131525585-1"},
    },{
      plugin: require('/home/shin/code/shiga-chinese-class.worktree/107da8e6-4337-48e5-869f-3e1eedd54774/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
